import {
  TTechClaimIntakeClient,
  TTechClaimIntakeClientConfig,
} from "@amzn/ttechclaimintakeservice-client";
import { buildConfigForEnvironment } from "../config";

type Request = {
  headers: {
    [key: string]: string;
  };
  credentials: string;
  url?: string;
  method?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- SDK middleware requires untyped body for request serialization
  body?: any;
};

export function setupClaimIntakeClient(token: string | null) {
  const config: TTechClaimIntakeClientConfig = buildConfigForEnvironment();
  config.maxAttempts = 1;
  const client: TTechClaimIntakeClient = new TTechClaimIntakeClient(config);

  // Add Authorization header with Cognito JWT token
  if (token) {
    client.middlewareStack.add(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- SDK middleware chain types are not exported
      (next: any) => (args: any) => {
        (args.request as Request).headers["Authorization"] = "Bearer " + token;
        return next(args);
      },
      { step: "build" }
    );
  } else {
    console.log(`[setupClaimIntakeClient] No token provided - requests will fail authentication`);
  }

  return client;
}
